<script lang="ts">
    import Button from "@components/Buttons/Button.svelte";
    import Icon from "@components/Icon.svelte";
    import ArrowIcon from "@components/icons/ArrowIcon.svelte";

    import ReviewsWizardManager from "../../managers/ReviewsWizardManager";

    export let reviewsWizardManager: ReviewsWizardManager;

    const nextButton$ = reviewsWizardManager.nextButton$;
    const prevButton$ = reviewsWizardManager.prevButton$;
</script>

<div class="gw-rv-form-modal-top-nav">
    <div class="gw-rv-form-modal-top-nav__left">
        {#if $prevButton$}
            <Button
                class="gw-rv-form-modal-top-nav__btn"
                on:click={$prevButton$.onClick}
                type="button"
                variant="text"
            >
                <Icon
                    class="gw-rv-form-modal-top-nav__back-arrow-icon"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                >
                    <ArrowIcon />
                </Icon>
            </Button>
        {/if}
    </div>
    <div class="gw-rv-form-modal-top-nav__right">
        {#if $nextButton$?.type === "skip"}
            <Button
                class="gw-rv-form-modal-top-nav__btn"
                on:click={$nextButton$.onClick}
                type="button"
                variant="text"
            >
                <!-- TODO: (Bektur) add translations -->
                <span class="gw-rv-form-modal-top-nav__btn-text"> Skip </span>
            </Button>
        {/if}
    </div>
</div>

<style lang="postcss">
    .gw-rv-form-modal-top-nav {
        display: none;
        justify-content: space-between;
        padding-top: 1em;

        @media screen and (max-width: 600px) {
            display: flex;
        }

        :global(&__back-arrow-icon) {
            transform: rotate(180deg);
        }

        :global(&__btn) {
            height: 100%;
        }

        &__btn-text {
            font-size: 16px;
        }
    }
</style>
